(() => {

    const hydrateDeferredMedia = () => {
      const root = document;
      const deferredMedia = root.querySelectorAll('img[data-src], img[data-srcset], source[data-src], source[data-srcset]');
      if (!deferredMedia.length) {
        return;
      }

      deferredMedia.forEach((element) => {
        // Skip elements inside inactive slides of a slideshow component
        if (element.closest('slideshow-slide[aria-hidden="true"]') || element.closest('slideshow-slide[inert]')) {
          return;
        }

        const dataSrcset = element.getAttribute('data-srcset');
        if (dataSrcset != null) {
          element.setAttribute('srcset', dataSrcset);
          element.removeAttribute('data-srcset');
        }

        const dataSrc = element.getAttribute('data-src');
        if (dataSrc != null) {
          element.setAttribute('src', dataSrc);
          element.removeAttribute('data-src');
        }

        if (element instanceof HTMLImageElement) {
          element.loading = 'eager';
          if (element.complete) {
            element.style.opacity = '';
          } else {
            element.addEventListener(
              'load',
              () => {
                element.style.opacity = '';
              },
              { once: true }
            );
          }
        }
      });
    };

    // HubSpot, LiveChat, and Trustpilot are owned by their consent helpers. The Shopify
    // apps still inject loaders into content_for_header → custom_scripts.
    // Trustpilot header.min.js / success.min.js call new URL(document.currentScript.src).
    // Termly Auto Blocker empties src on decline, so injecting them anyway throws
    // "Failed to construct 'URL': Invalid URL".
    const isConsentGatedAppScript = (url) =>
      /hubapi\.com\/scriptloader|hs-scripts\.com|hs-analytics\.net|livechatinc\.com|cdn\.livechatinc\.com|trustpilot\.com/i.test(
        String(url || '')
      );

    const TERMLY_CACHE_KEY = 'TERMLY_API_CACHE';
    const TERMLY_CONSENT_KEY = 'TERMLY_COOKIE_CONSENT';
    let termlyEventDecision = null;
    let trustpilotLoaded = false;
    let userInteracted = false;

    const isGranted = (value) => value === true || value === 'true' || value === 'yes' || value === 1;

    const isDesignMode = () => document.documentElement.classList.contains('shopify-design-mode');

    const termlyExpected = () =>
      Boolean(window.Termly || document.querySelector('script[src*="app.termly.io"]'));

    const termlyStoredConsents = () => {
      try {
        const raw = window.localStorage.getItem(TERMLY_CACHE_KEY);
        if (!raw) return null;
        const entry = JSON.parse(raw)[TERMLY_CONSENT_KEY];
        if (!entry || entry.value == null || typeof entry.value !== 'object') return null;
        return entry.value;
      } catch (error) {
        return null;
      }
    };

    const categoriesToState = (categories) => {
      if (!Array.isArray(categories)) return null;
      const set = new Set(categories.map((name) => String(name)));
      return {
        analytics: set.has('analytics'),
        advertising: set.has('advertising'),
      };
    };

    const rememberTermlyDecision = (data) => {
      if (!data || typeof data !== 'object') return;
      if (data.consentState && typeof data.consentState === 'object') {
        termlyEventDecision = data.consentState;
        return;
      }
      const fromCategories = categoriesToState(data.categories);
      if (fromCategories) termlyEventDecision = fromCategories;
    };

    const explicitTermly = () => {
      if (termlyEventDecision && typeof termlyEventDecision === 'object') return termlyEventDecision;
      return termlyStoredConsents();
    };

    const trustpilotAllowed = () => {
      if (isDesignMode()) return true;

      const termly = explicitTermly();
      const privacy = window.Shopify && window.Shopify.customerPrivacy;
      const shopifyReady = Boolean(privacy && typeof privacy.analyticsProcessingAllowed === 'function');

      if (!termly && !shopifyReady) return false;
      if (shopifyReady && typeof privacy.saleOfDataAllowed === 'function' && privacy.saleOfDataAllowed() === false) {
        return false;
      }
      if (termly && !isGranted(termly.analytics) && !isGranted(termly.advertising)) return false;
      if (shopifyReady && privacy.analyticsProcessingAllowed() !== true && privacy.marketingAllowed() !== true) {
        return false;
      }
      if (termlyExpected()) {
        if (!termly) return false;
        return isGranted(termly.analytics) || isGranted(termly.advertising);
      }
      return shopifyReady && (privacy.analyticsProcessingAllowed() === true || privacy.marketingAllowed() === true);
    };

    const loadTrustpilotScripts = () => {
      if (trustpilotLoaded || !userInteracted || !trustpilotAllowed()) return;
      const scripts = window.__tileclubTrustpilotScripts || [];
      if (!scripts.length) {
        trustpilotLoaded = true;
        return;
      }
      trustpilotLoaded = true;
      scripts.forEach((src) => {
        const script = document.createElement('script');
        // Inserted only after an explicit grant. essential stops Termly from clearing src
        // on the way in, which is what makes new URL(document.currentScript.src) throw.
        script.setAttribute('data-categories', 'essential');
        script.setAttribute('src', src);
        script.async = true;
        document.head.appendChild(script);
      });
    };

    const loadCustomScripts = () => {
        const scripts = window.custom_scripts || [];
        scripts.forEach(script => {
            if (isConsentGatedAppScript(script)) return;
            let s = document.createElement('script');
            s.setAttribute('src', script);
            document.head.insertAdjacentElement("beforeend", s);
        });
    };

    const loadBingUET = () => {
      (function (w, d, t, r, u) {
        var f, n, i;
        (w[u] = w[u] || []),
          (f = function () {
            var o = { ti: '56297450' };
            (o.q = w[u]), (w[u] = new UET(o)), w[u].push('pageLoad');
          }),
          (n = d.createElement(t)),
          (n.src = r),
          (n.async = 1),
          (n.onload = n.onreadystatechange =
            function () {
              var s = this.readyState;
              (s && s !== 'loaded' && s !== 'complete') || (f(), (n.onload = n.onreadystatechange = null));
            }),
          (i = d.getElementsByTagName(t)[0]),
          i.parentNode.insertBefore(n, i);
      })(window, document, 'script', '//bat.bing.com/bat.js', 'uetq');
    };

    const loadClarity = () => {
        (function(c,l,a,r,i,t,y){
            c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
            t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
            y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
        })(window, document, "clarity", "script", "opte3jlu0j");
    }

    const loadLinkedInInsight = () => {
      _linkedin_partner_id = '7565058';
      window._linkedin_data_partner_ids = window._linkedin_data_partner_ids || [];
      window._linkedin_data_partner_ids.push(_linkedin_partner_id);
      (function (l) {
        if (!l) {
          window.lintrk = function (a, b) {
            window.lintrk.q.push([a, b]);
          };
          window.lintrk.q = [];
        }
        var s = document.getElementsByTagName('script')[0];
        var b = document.createElement('script');
        b.type = 'text/javascript';
        b.async = true;
        b.src = 'https://snap.licdn.com/li.lms-analytics/insight.min.js';
        s.parentNode.insertBefore(b, s);
      })(window.lintrk);
    }

    const loadMinMaxify = () => {
      let s = document.createElement('script');
      s.setAttribute('src', 'https://limits.minmaxify.com/tileboom.myshopify.com?v=200&r=20231019171051&shop=tileboom.myshopify.com');
      document.head.insertAdjacentElement("beforeend", s);
    }

    const loadKlaviyo = () => {
      let s = document.createElement('script');
      s.setAttribute('src', 'https://static.klaviyo.com/onsite/js/klaviyo.js?company_id=T5VFJc');
      s.async = true;
      document.head.insertAdjacentElement("beforeend", s);
    }

    const loadFormBuilderHelper = () => {
        const script = document.createElement('script');
        script.src = "https://ecf.cirkleinc.com/public/frontend/js/form-builder-helper.js";
        script.async = true;
        document.head.insertAdjacentElement("beforeend", script);
    };

    const loadReviewsIO = () => {
      // Inject Reviews.io CSS
      let link = document.createElement('link');
      link.rel = 'stylesheet';
      link.href = "https://widget.reviews.io/rating-snippet/dist.css";
      document.head.appendChild(link);

      // Product Card Reviews
      const a = document.createElement('script');
      a.src = 'https://widget.reviews.io/rating-snippet/dist.js';
      document.head.insertAdjacentElement("beforeend", a);
      a.onload = function () {
        ratingSnippet("ruk_rating_snippet", {
          store: "tileclub.com",
          mode: 'minimal',
          color: "#c9921f",
          textClr: '#2b2624',
          linebreak: false,
          text: " ",
          singularText: " ",
          lang: "en",
          usePolaris: true,
          showEmptyStars: false,
          showNumericalAverageRating: true,
        });
      };

      // Rating Bar Reviews HP and PLP
      const widget = document.querySelector(".reviews-io-rating-bar-widget");
      if (widget) {
        (function () {
          const OriginalRO = window.ResizeObserver;

          window.ResizeObserver = class extends OriginalRO {
            constructor(callback) {
              super((entries, observer) => {
                entries.forEach(e => {
                  if (
                    e.target.classList.contains('RatingBarWidget') &&
                    e.target.classList.contains('R-isLoaded')
                  ) {
                    requestAnimationFrame(() => callback([e], observer));
                  } else {
                    callback([e], observer);
                  }
                });
              });
            }
          };
        })();
        widget.setAttribute("data-store-name",'tileboom.myshopify.com');
        widget.setAttribute("lang",'en');
        let ratingBarScript = document.createElement("script");
        ratingBarScript.setAttribute("src", "//widget.reviews.io/modern-widgets/rating-bar.js");
        document.body.appendChild(ratingBarScript);
      }
    }


    const loadScripts = () => {
      userInteracted = true;
      hydrateDeferredMedia(document);
        loadCustomScripts();
        loadTrustpilotScripts();
        requestAnimationFrame(loadReviewsIO);
        loadKlaviyo();
        loadClarity();
        loadLinkedInInsight();
        loadBingUET();
        loadMinMaxify();
        loadFormBuilderHelper();
    }
    document.addEventListener('UserInteracted', loadScripts, false);
    document.addEventListener('visitorConsentCollected', loadTrustpilotScripts);

    const listenTermly = () => {
      if (!window.Termly || typeof window.Termly.on !== 'function') return false;
      window.Termly.on('consent', (data) => {
        rememberTermlyDecision(data);
        loadTrustpilotScripts();
      });
      window.Termly.on('initialized', () => {
        loadTrustpilotScripts();
      });
      return true;
    };

    if (!listenTermly() && termlyExpected()) {
      const started = Date.now();
      const timer = setInterval(() => {
        if (listenTermly() || Date.now() - started > 10000) clearInterval(timer);
      }, 50);
    }
})();